import React from 'react'
import styles from './styles'
import { css } from 'aphrodite'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import isAdmin from 'utils/isAdmin'

const Attest = connect(
  {
    attestOrders: state`orderHistory.attestOrders`,
    loadAttestOrders: signal`orderHistory.loadAttestOrders`,
    group: state`app.user.group`
  },
  ({ attestOrders, loadAttestOrders, group }) => {
    if (!isAdmin(group)) return null
    const attestCount = Object.keys(attestOrders).length
    return (
      <div
        style={{ display: 'inline-block' }}
        onClick={e => {
          if (attestCount > 0) {
            loadAttestOrders()
          }
        }}
      >
        <div
          style={{
            position: 'relative',
            width: 45,
            height: 45,
            paddingTop: 6,
            paddingLeft: 10
          }}
        >
          <div
            className={css(
              styles.badgeContainer,
              attestCount === 0 ? styles.badgeContainerNoOrders : null
            )}
          >
            <span>{attestCount}</span>
          </div>
          <svg
            className={css(
              styles.container,
              attestCount === 0 ? styles.noOrders : null
            )}
            viewBox={'0 -6 38 38'}
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
          </svg>
        </div>
      </div>
    )
  }
)

export default Attest



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Attest/attest.js